const $ = window.jQuery;

class Cursor {
  constructor($element) {
    this.$element = $element;
    this.state = {
      hasMoved: false
    };

    this.addListeners();
  }

  addListeners() {
    $(window)
      .on('mousemove', (event) => {
        if (!this.state.hasMoved) {
          this.state.hasMoved = true;
          this.$element.addClass('cursor--state-has-moved');
        }
        this.positionElement(event);
      })
      .mouseup(() => {
        this.$element.removeClass('cursor--state-is-clicking');
      })
      .mousedown(() => {
        this.$element.addClass('cursor--state-is-clicking');
      });
  }

  positionElement(event) {
    const mouse = {
      x: event.clientX,
      y: event.clientY
    };

    this.$element.css({
      top: mouse.y + 'px',
      left: mouse.x + 'px'
    });
  }
}

const $body = $('body').append('<div id="cursor" />');
const $cursor = $('#cursor');

new Cursor($cursor);
